import { Component, inject } from '@angular/core';
import { NotificationHistoryDTO, NotificationHistoryReadAllPaginatedRequestDTO, NotificationHistoryUpdateStatusByIdRequestDTO } from './history.interface';
import { PaginatedDTO } from 'src/app/Common/common.interface';
import { UserLoginService } from 'src/app/Common/UserLoginService/userlogin.service';
import { environment } from 'src/environments/environment';
import { HistoryService } from './history.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { dateRangeValidator } from 'src/app/Shared/validators/dateRangeValidator';
import { end } from '@popperjs/core';
import { GenericListUicService } from 'src/app/Common/UICServices/ListUIC/list-uic.service';
import { GenericListUICDTO, GenericListUICReadByTenantIdRequestDTO } from 'src/app/Common/UICServices/ListUIC/list-uic.interface';
import { UICMasterType } from 'src/app/Common/UICServices/uic.enum';
import { ColorColumns } from 'src/app/Shared/color-table/color-table.interface';

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.css']
})
export class HistoryComponent {
  //
  statusOptions: string[] = ['Pending', 'Cancelled'];
  selectedRowIndex: number | null = null;
  selectedIndexes: number[] = [];
  popupVisible: boolean = false;
  isLoading = false;
  sideForm: Boolean = false
  editFlag: boolean = false;
  gListUICService = inject(GenericListUicService);
  gListUIC: GenericListUICDTO[] = []
  notifHistoryData: NotificationHistoryDTO[] = []
  private historyService = inject(HistoryService)
  // notificationList: NotificationHistoryDTO[] = []
  User = inject(UserLoginService).User();
  tableCol: ColorColumns[] = []
  dateForm = new FormGroup({
    startDate: new FormControl('', [Validators.required]),
    endDate: new FormControl('', [Validators.required]),
    whereClause: new FormControl(''),
  }, { validators: dateRangeValidator() })

  today = new Date();
  oneMonthAgo = new Date();

  NotificationHistoryForm = new FormGroup({
    notificationId: new FormControl(0),
    nStatus: new FormControl("", Validators.required),
    remarks: new FormControl("", Validators.required)
  })

  HistoryDTO: NotificationHistoryReadAllPaginatedRequestDTO = {
    tenantId: this.User.companyId,
    tenantBranchId: this.User.loggedInBranchId,
    softwareId: parseInt(environment.SoftwareId),
    pageNo: 1,
    pageSize: 10,
    startDate: this.formatDate(this.oneMonthAgo),
    endDate: this.formatBackendEndDate(this.today),
    whereClause: '',
    orderByClause: ''
  }

  formatBackendEndDate(date: Date): string {
    const backendEndDate = new Date(date);
    backendEndDate.setDate(backendEndDate.getDate() + 1);
    return this.formatDate(backendEndDate);
  }

  toggleAll(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;

    // Use existing paginated filter DTO
    this.historyService.history_readAllPaginated(this.HistoryDTO).subscribe(data => {
      this.notifHistoryData = data.items.map((row, index) => {
        const isSelectable = row.nStatus !== 'Success';

        if (isSelectable && checked) {
          if (!this.selectedIndexes.includes(index)) {
            this.selectedIndexes.push(index);
          }
        } else if (!checked) {
          this.selectedIndexes = this.selectedIndexes.filter(i => i !== index);
        }

        return {
          ...row,
          selected: checked && isSelectable
        };
      });

      this.editFlag = this.selectedIndexes.length > 0;

    });
  }

  areAllSelectableRowsSelected(): boolean {
    // Only consider rows that are selectable (status !== 'Success')
    const selectableRows = this.notifHistoryData.filter(row => row.nStatus !== 'Success');

    // If no selectable rows, don't check the checkbox
    if (selectableRows.length === 0) return false;

    // Return true only if all selectable rows are selected
    return selectableRows.every(row => row.selected);
  }



  toggleSelection(index: number) {
    const row = this.notifHistoryData[index];

    if (row.nStatus === 'Success') {
      // Prevent selection and optionally alert the user
      alert('Rows with status "Success" cannot be selected.');
      return;
    }

    if (this.selectedIndexes.includes(index)) {
      this.selectedIndexes = this.selectedIndexes.filter(i => i !== index);
    } else {
      this.selectedIndexes.push(index);
    }

    this.editFlag = this.selectedIndexes.length > 0;
  }




  BulkEdit() {
    if (this.selectedIndexes && this.selectedIndexes.length > 0) {
      this.popupVisible = true;
    } else {
      alert('Please select at least one row.');
    }
  }


  formatDate(date: Date): string {
    return date.toISOString().split('T')[0];
  }

  ngOnInit(): void {

    this.GetTableUI();

    this.oneMonthAgo.setMonth(this.today.getMonth() - 1);

    this.dateForm.patchValue({
      startDate: this.formatDate(this.oneMonthAgo),
      endDate: this.formatDate(this.today),
    });

    this.HistoryDTO = {
      pageSize: 10,
      pageNo: 1,

      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId,
      softwareId: parseInt(environment.SoftwareId),

      startDate: this.formatDate(this.oneMonthAgo),
      endDate: this.formatBackendEndDate(this.today),

      whereClause: '',
      orderByClause: ''
    };

    this.getNotificationHistoryList(this.HistoryDTO);
  }

  enableRemarksEdit(row: NotificationHistoryDTO) {
    row.remarksEdit = true;

  }

  cancelRemark(row: NotificationHistoryDTO) {
    row.remarksEdit = false;

  }
  onStatusChange(row: NotificationHistoryDTO): void {
    this.NotificationHistoryForm.markAllAsTouched();

    let updateRequest: NotificationHistoryUpdateStatusByIdRequestDTO = {
      notificationId: row.notificationId ?? 0,
      tenantId: row.tenantId ?? this.User.companyId,
      tenantBranchId: row.tenantBranchId ?? this.User.loggedInBranchId,
      nStatus: row.nStatus ?? "",
      remarks: row.remarks ?? "",
      actionUser: this.User.userId.toString()
    };

    this.historyService.notificationMaster_UpdateStatusById(updateRequest).subscribe({
      next: (res) => {
        row = res;
        row.statusEdit = false;
        row.remarksEdit = false; // Close edit mode
        // const index = this.notifHistoryData.findIndex(r => r.notificationId === row.notificationId);

        // if (index !== -1) {
        //   this.notifHistoryData[index] = res;
        // }

      },
      error: (err) => {

        console.error(err);
      }
    });

  }

  getSelectedRows(): NotificationHistoryDTO[] {
    return this.selectedIndexes.map(i => this.notifHistoryData[i]);
  }
  onSubmitAction(): void {
    this.NotificationHistoryForm.markAllAsTouched();

    if (this.NotificationHistoryForm.invalid) return;

    let updatedStatus = this.NotificationHistoryForm.value.nStatus ?? '';
    let updatedRemarks = this.NotificationHistoryForm.value.remarks ?? '';
    const selectedRows = this.getSelectedRows()
    selectedRows.forEach(row => {
      if (row.nStatus === 'Success') {
        console.log(`Skipping row with ID ${row.notificationId} because status is already 'Success'.`);
        return;
      }
      const updateRequest: NotificationHistoryUpdateStatusByIdRequestDTO = {
        notificationId: row.notificationId ?? 0,
        tenantId: row.tenantId ?? this.User.companyId,
        tenantBranchId: row.tenantBranchId ?? this.User.loggedInBranchId,
        nStatus: updatedStatus,
        remarks: updatedRemarks,
        actionUser: this.User.userId.toString()
      };

      this.historyService.notificationMaster_UpdateStatusById(updateRequest).subscribe({
        next: (res) => {
          const index = this.notifHistoryData.findIndex(r => r.notificationId === row.notificationId);
          if (index !== -1) {
            this.notifHistoryData[index] = res;
          }
        },
        error: (err) => {
          console.error('Bulk update failed for ID:', row.notificationId, err);
        }
      });
    });

    this.selectedIndexes = [];
    this.popupVisible = false;
    this.NotificationHistoryForm.reset();

  }


  handlePageSizeChange(event: { currentPage: number; pageSize: number; }) {

    const { currentPage, pageSize } = event;

    const formValue = this.dateForm.value;

    const startDate = new Date(formValue.startDate as string);
    const endDate = new Date(formValue.endDate as string);

    this.HistoryDTO = {

      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId,
      softwareId: parseInt(environment.SoftwareId),

      pageNo: currentPage,
      pageSize: pageSize,

      startDate: this.formatDate(startDate),
      endDate: this.formatBackendEndDate(endDate),

      whereClause: '',
      orderByClause: ''
    };

    this.getNotificationHistoryList(this.HistoryDTO);
  }
  getNotificationHistoryList(data: NotificationHistoryReadAllPaginatedRequestDTO) {
    this.isLoading = true;
    const searchText = this.dateForm.controls.whereClause.value?.trim() || '';
    let whereClause = '';

    if (searchText) {
      whereClause = `(NSubject LIKE '%${searchText}%' OR Remarks LIKE '%${searchText}%' OR NTo LIKE '%${searchText}%' OR NStatus LIKE '%${searchText}%')`;
    }
    data.whereClause = whereClause;
    this.historyService.history_readAllPaginated(data).subscribe({
      next: (response) => {
        this.notifHistoryData = response.items;
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error fetching whatsapp config list:', err);
        this.isLoading = false;
      }
    })
  }

  handleActionClick(event: { actionName: string, rowData: NotificationHistoryDTO }) {
    const formData = event.rowData
  }
  GetTableUI() {
    let data: GenericListUICReadByTenantIdRequestDTO = {
      masterType: UICMasterType.NotifHistoryList,
      tenantId: this.User.companyId
    }
    this.gListUICService.GenericListUIC_ReadByTenantId(data).subscribe(res => {

      this.gListUIC = res.items

      this.gListUIC.forEach(element => {


        if (element.isUIVisible == 1) {

          let col: ColorColumns = {
            colName: element.uiLabel,
            colData: element.propertyName,
            colStyle: element.uiStyle
          }
          this.tableCol.push(col)
        }

      });
      this.tableCol.unshift({ colName: 'SrNo.', colData: 'rowNum' })

      this.getNotificationHistoryList(this.HistoryDTO)
    })
  }

  loadDataByDate() {

    this.dateForm.markAllAsTouched();

    if (this.dateForm.valid) {

      const formValue = this.dateForm.value;

      const startDate = new Date(formValue.startDate as string);
      const endDate = new Date(formValue.endDate as string);

      this.HistoryDTO = {

        pageNo: this.HistoryDTO.pageNo,
        pageSize: this.HistoryDTO.pageSize,

        tenantId: this.User.companyId,
        softwareId: parseInt(environment.SoftwareId),
        tenantBranchId: this.User.loggedInBranchId,

        whereClause: '',
        orderByClause: '',

        startDate: this.formatDate(startDate),
        endDate: this.formatBackendEndDate(endDate),
      };

      this.getNotificationHistoryList(this.HistoryDTO);
    }
  }


  clearSearchAndReload(): void {

    this.oneMonthAgo = new Date();
    this.oneMonthAgo.setMonth(this.today.getMonth() - 1);

    this.dateForm.patchValue({
      startDate: this.formatDate(this.oneMonthAgo),
      endDate: this.formatDate(this.today),
      whereClause: ''
    });

    this.HistoryDTO = {

      pageNo: this.HistoryDTO.pageNo,
      pageSize: this.HistoryDTO.pageSize,

      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId,
      softwareId: parseInt(environment.SoftwareId),

      whereClause: '',
      orderByClause: '',

      startDate: this.formatDate(this.oneMonthAgo),
      endDate: this.formatBackendEndDate(this.today),
    };

    this.getNotificationHistoryList(this.HistoryDTO);
  }
  closePopup(event: MouseEvent) {
    event.stopPropagation();            // Prevent re-triggering td click
    this.selectedRowIndex = null;       //  Close the popup
    this.NotificationHistoryForm.reset();   // Optional: Reset the form
    document.body.classList.remove('blur');
  }

  openPopup(index: number, item: NotificationHistoryDTO): void {
    this.selectedRowIndex = index;
    this.NotificationHistoryForm.patchValue({
      notificationId: item.notificationId,
      nStatus: item.nStatus,
    })
    document.body.classList.add('blur');
  }

  selectRow(index: number) {
    this.selectedRowIndex = index;
  }
}
